import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const AWSIcon = forwardRef<SVGSVGElement, IconProps>(function AWSIcon(
  { color = '#9E8AD9', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M1.35385 3.61865L0 8.381H0.793639L1.10094 7.21388H2.49481L2.78825 8.381H3.58189L2.32807 3.61865H1.35385ZM1.24048 6.60647L1.80736 4.2589H1.82019L2.36706 6.60647H1.24048Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M7.33813 7.34009H7.32428L6.68403 3.61865H5.88372L5.25733 7.31956H5.24348L4.61708 3.61865H3.84961L4.77048 8.381H5.65081L6.2572 4.79295H6.27105L6.88462 8.381H7.76496L8.71148 3.61865H7.95837L7.33813 7.34009Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M11.0321 5.77935L10.5191 5.59209C10.0122 5.39869 9.80499 5.19245 9.80499 4.78563C9.80499 4.27877 10.1184 4.09819 10.4452 4.09819C10.9187 4.09819 11.1122 4.35162 11.1122 4.78563V4.88567H11.8724V4.77845C11.8724 4.28544 11.7457 3.52515 10.5253 3.52515C9.63159 3.52515 9.0447 4.00533 9.0447 4.87285C9.0447 5.55311 9.3443 5.91273 10.0384 6.1795L10.5591 6.36008C10.986 6.48629 11.2389 6.70688 11.2389 7.20656C11.2389 7.56003 10.9988 7.90119 10.5191 7.90119C9.99224 7.90119 9.73881 7.60774 9.73881 7.02752V6.90747H8.97852V7.02085C8.97852 7.68829 9.2458 8.47474 10.4257 8.47474C11.3861 8.47474 11.9997 8.05509 11.9997 7.04086C11.9997 6.38625 11.7057 6.01841 11.0321 5.77935Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
